<template>
    <button v-if="config.enabled" class="btn powered-by-tc"  v-bind="config.attrs">
      <p class="powered-by">
					<span>{{content.poweredByTC}}</span>
          <svg viewBox="58 200.9231 32 14.0996" width="26" height="14.0996" xmlns="http://www.w3.org/2000/svg">
  <g transform="matrix(0.007233000360429286, 0, 0, -0.007233000360429286, 58.098720550537095, 218.1186828613281)" fill="#fff" stroke="none">
    <path d="M850 2060 c-156 -99 -290 -187 -297 -196 -18 -24 -18 -345 -1 -362 7 -7 43 -12 90 -12 72 0 78 -2 83 -22 2 -13 6 -180 8 -373 l3 -350 27 -80 c33 -99 59 -142 126 -210 58 -59 142 -104 241 -131 79 -22 338 -26 383 -6 l27 12 -2 187 -3 188 -120 5 c-134 6 -153 13 -202 77 l-28 36 0 331 0 331 175 5 175 5 0 190 0 190 -175 5 -175 5 -3 178 c-2 176 -3 177 -25 176 -12 -1 -150 -81 -307 -179z"/>
    <path d="M2159 1890 c-240 -59 -439 -225 -543 -452 -54 -117 -70 -196 -70 -338 0 -142 16 -221 70 -338 84 -185 236 -333 422 -412 169 -72 396 -80 572 -21 52 18 126 50 163 72 89 53 197 154 197 184 0 16 -37 58 -129 144 -71 66 -134 121 -141 121 -6 0 -32 -18 -57 -40 -160 -141 -392 -143 -541 -5 -249 230 -119 646 215 691 98 13 232 -32 316 -106 25 -22 52 -40 60 -40 19 0 267 262 267 282 0 21 -94 108 -165 153 -76 49 -180 91 -270 110 -102 21 -270 18 -366 -5z"/>
    <path d="M3609 1332 c-187 -97 -187 -367 0 -464 95 -50 217 -36 296 34 121 107 121 289 0 396 -79 70 -201 84 -296 34z"/>
  </g>
          </svg>
				</p>
    </button>
  </template>
  
  <script>
import featureMixin from "@/mixins/featureMixin";

  export default {
    name: "PoweredByTC",
    mixins: [featureMixin],
	data(){
		return {
			featurePath: 'poweredByTC'
		}
	},
  }
  </script>
  
  <style lang="scss">
  .flyer-content button.powered-by-tc {
    margin: 0 auto !important;
     cursor: default;
     position: absolute;
     left: 0;
    right: 0;
    width: 155px;
    min-width: 150px;
    bottom: 0px;
    background: #000;
    height: 34px;
    display:flex;
    padding: 0 25px;
    min-height: unset;
    border-radius: 12px 12px 0 0;
    -webkit-tap-highlight-color: transparent;

    .powered-by{
      color: #fff;
       display: flex;
       align-items: center;
       font-size: 12px;
         span {
          position: unset;
            margin-left: 3px ;
         }
    }
    &:hover {
        filter: none;
        color: unset;
       
    }
  }
  button.powered-by-tc {
    display: none;
  }
    
  </style>
  